module.exports = __webpack_public_path__ + "img/front_earth.0ca01b1b.png";